// Project context — the currently selected project, used by every page
// inside the project layout.

import { createContext, useContext } from "react";
import type { ProjectSummary } from "./types";

interface ProjectContextValue {
  project: ProjectSummary;
  refreshProjects: () => Promise<void>;
}

export const ProjectContext = createContext<ProjectContextValue | undefined>(undefined);

export function useProject(): ProjectContextValue {
  const value = useContext(ProjectContext);
  if (!value) throw new Error("useProject must be used inside a ProjectContext provider");
  return value;
}
